<template>
  <div class="hearTopBox">
    <div class="fixBox">
      <div class="heardContent">
        <div class="heardLeft">
          <img src="https://htmlqiniu.jihex.com/homepage/logo.png" alt="">
          <ul class="ulBox">
            <li>
              <a :class="activeIndex==0?'activeStyle':''" @click="selectTab(0)" href="javascript:;">首页</a>
            </li>
            <li><a :class="activeIndex==1?'activeStyle':''" @click="selectTab(1)" href="javascript:;">产品与服务</a></li>
            <li><a :class="activeIndex==2?'activeStyle':''" @click="selectTab(2)" href="javascript:;">服务内容</a></li>
            <li><a :class="activeIndex==3?'activeStyle':''" @click="selectTab(3)" href="javascript:;">关于太目</a></li>
            <li :class="`lineBox${activeIndex}`" class="lineBox"></li>
          </ul>
        </div>
        <div class="heardRight">
          <div @click="showConsultationQR" class="loginBox">在线咨询</div>
          <div @click="clickRegister" class="loginBox">免费试用</div>
          <div @click="clickLogin" class="registerBox">登录</div>
        </div>
      </div>
    </div>
    
    <!-- 在线咨询二维码弹窗 -->
    <div v-if="showQRDialog" class="qr-overlay" @click="closeQRDialog">
      <div class="qr-dialog" @click.stop>
        <div class="qr-header">
          <span></span>
          <span class="close-btn" @click="closeQRDialog">×</span>
        </div>
        <div class="qr-content">
          <img class="qr-image" src="https://htmlqiniu.jihex.com/2f16048b31b719b17017f48bf37a583a_compress.jpg" alt="在线咨询二维码">
        </div>
      </div>
    </div>
    
    <loginDia v-if="loginDiaShow" v-model="loginDiaShow" @changeEvent="clickRegister"></loginDia>
    <registerDia v-if="registerShow" v-model="registerShow" />
  </div>
</template>

<script>
import loginDia from '@/components/loginDia'
import registerDia from '@/components/registerDia';
import webHost from '@/api/config.js'
export default {
  components:{
    loginDia,
    registerDia
  },
  data () {
    return {
      activeIndex:0,
      registerShow:false,
      loginDiaShow:false,
      showQRDialog: false
    }
  },
  methods:{
    selectTab(num) {
      this.activeIndex = num;
      if(num==0) {
        this.$router.push({ name: "HomePage" });
      }else if(num==1) {
        this.$router.push({ name: "IntroductionPage" });
      }else if(num==2) {
        this.$router.push({ name: "Membership" });
      }else if(num==3) {
        this.$router.push({ name: "AboutUs" });
      }
    },
    // 显示在线咨询二维码
    showConsultationQR() {
      this.showQRDialog = true;
    },
    // 关闭二维码对话框
    closeQRDialog() {
      this.showQRDialog = false;
    },
    clickRegister() {
      window.open(`${webHost}/#/login?isRegisterShow=true`)
      // this.$nextTick(() => {
      //   this.registerShow = true
      //   this.loginDiaShow = false
			// })
    },
    clickLogin() {
      console.log(999)
      window.open(`${webHost}/#/login`)
      // this.$nextTick(() => {
			// 	this.loginDiaShow = true
			// })
      // console.log('loginDiaShow')
    }
  },
  mounted() {
    // console.log(this.$router.history.current.name)
    if(this.$router.history.current.name=='HomePage') {
      this.activeIndex = '0'
    }else if(this.$router.history.current.name=='IntroductionPage') {
      this.activeIndex = '1'
    }else if(this.$router.history.current.name=='Membership') {
      this.activeIndex = '2'
    }else if(this.$router.history.current.name=='AboutUs') {
      this.activeIndex = '3'
    }
  }
}
</script>

<style lang="scss" scoped>
 .fixBox {
   position: fixed;
   left: 0;
   right: 0;
   width: 100%;
   background: #ffffff;
   z-index: 99;
 }
 .hearTopBox {
   width: 100%;
   height: 64px;
   background: #ffffff;
   .heardContent {
     width: 1200px;
     margin: 0 auto;
     padding: 0 10px;
     box-sizing: border-box;
     display: flex;
     align-items: center;
     justify-content: space-between;
     .heardLeft {
       display: flex;
       align-items: center;
       img {
         width: 140px;
         height: 28px;
         display: block;
         margin-right: 56px;
       }
       .heardTitle {
         margin-left: 10px;
         font-size:18px;
         font-weight:600;
         color:rgba(67,69,71,1);
         line-height:28px;
         margin-right: 60px;
       }
     }
     ul,li {
       margin: 0;
       padding: 0;
       list-style: none;
     }
     .heardLeft,.heardRight {
       height: 64px;
       line-height: 64px;
       display: flex;
       align-items: center;
       ul {
         display: flex;
         align-items: center;
         position: relative;
       }
       .lineBox {
         position: absolute;
         left: 20px;
         top: 60px;
         width: 28px;
         height: 4px;
         background: #3371FF;
         padding: 0px;
         transition: all 200ms linear;
       }
       .lineBox1 {
         left: 108px;
       }
       .lineBox2 {
         left: 210px;
       }
       .lineBox3 {
         left: 308px;
       }
       li {
         height: 64px;
         padding: 0 20px;
          a {
            text-decoration: none;
            color: #434547;
            display: block;
            height: 64px;
            font-weight:600;
            font-size:14px;
            box-sizing: border-box;
            &:hover {
              color: #3371FF;
            }
          }
          .activeStyle {
            // border-bottom: 4px solid #FD7D6F;
            color: #3371FF;
          }

       }
     }
   }
 }
 .registerBox {
   height: 32px;
   line-height: 32px;
   padding: 0 26px;
   background:#FAFBFF;
   border-radius:16px;
   border:1px solid #3371FF;
   font-size:14px;
   color:#3371FF;
   margin-left: 20px;
   box-sizing: border-box;
   &:hover {
     background: #3371FF;
     color: #fff;
     cursor: pointer;
   }
 }
 .loginBox {
  height:32px;
  background:linear-gradient(270deg, #3371FF 0%, #3371FF 100%);
  border-radius:16px;
  padding: 0 26px;
  line-height: 32px;
  font-size:14px;
  margin-left:10px;
  color:rgba(255,255,255,1);
  &:hover {
    background:linear-gradient(270deg, #4691f3, #4691f3 100%);
    cursor: pointer;
  }
 }
 
   // 样式：二维码弹窗覆盖层
   .qr-overlay {
     position: fixed;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     background-color: rgba(0, 0, 0, 0.5);
     display: flex;
     justify-content: center;
     align-items: center;
     z-index: 10000;
   }
   
   .qr-dialog {
     background: white;
     border-radius: 8px;
     width: 500px;
     padding: 20px;
     text-align: center;
     box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
     
     .qr-header {
       display: flex;
       justify-content: space-between;
       align-items: center;
       
       span {
         font-size: 16px;
         font-weight: bold;
         color: #333;
       }
       
       .close-btn {
         cursor: pointer;
         font-size: 24px;
         color: #999;
         &:hover {
           color: #333;
         }
       }
     }
     
     .qr-content {
       .qr-image {
         width: 400px;
         height: 400px;
         margin: 10px auto;
         display: block;
       }
       
       .qr-tip {
         margin-top: 10px;
         font-size: 14px;
         color: #666;
       }
     }
 }
</style>



// WEBPACK FOOTER //
// src/components/navTop/hearTop.vue